<p-split-button
    [label]="'delay-request.label' | translate"
    [outlined]="true"
    icon="pi pi-exclamation-triangle"
    severity="warn"
    [model]="commands()"
    (onClick)="continueFirst()"
    [appendTo]="undefined"
></p-split-button>
